module.exports = __webpack_public_path__ + "static/img/Frame 1853.a0adf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1853.png
// module id = 5oy2
// module chunks = 12